<template>
  <v-row justify="center">
    <v-date-picker
      v-model="picker"
      type="month"
      year-icon="mdi-calendar-blank"
      prev-icon="mdi-skip-previous"
      next-icon="mdi-skip-next"
    ></v-date-picker>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      picker: new Date().toISOString().substr(0, 7)
    };
  }
};
</script>
